import { useEffect } from 'react';
import { getBaseUrlByEnv } from '@/constants/baseUrls';
import useGlobalStore from '@/data-store/zustand/hooks/useGlobalStore';
import getEnv, { Environment } from '@/utils/environment';
import { FEATURE_FLAGS } from '@/utils/featureFlags/constants';
import { isTruthyFlagValue } from '@/utils/featureFlags/featureFlagHelpers';

/** Returns true while the page should render nothing. */
export function useRedirectToSolarQuoteInProd(): boolean {
  const { featureFlags } = useGlobalStore('featureFlags');
  const isProd = getEnv() === Environment.PROD;
  const isPending = isProd && featureFlags === undefined;
  const shouldRedirect =
    isProd &&
    !isPending &&
    !isTruthyFlagValue(featureFlags?.[FEATURE_FLAGS.SHOW_SOLAR_ECOMM_PROD]);

  useEffect(() => {
    if (shouldRedirect) {
      window.location.replace(`${getBaseUrlByEnv()}/shop/solar-quote/`);
    }
  }, [shouldRedirect]);

  return isPending || shouldRedirect;
}
